class BaseError extends Error {
  constructor() {
    super();

    this.name = this.constructor.name;
  }
}

export default BaseError;
